import { render, staticRenderFns } from "./SessionColumn.vue?vue&type=template&id=a4b149d0&scoped=true&"
import script from "./SessionColumn.vue?vue&type=script&lang=js&"
export * from "./SessionColumn.vue?vue&type=script&lang=js&"
import style0 from "./SessionColumn.vue?vue&type=style&index=0&id=a4b149d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4b149d0",
  null
  
)

export default component.exports